import * as React from 'react';

import { useTheme } from '../../../hooks/useTheme';
import { Flex } from '../../common/Flex';
import { Icon } from '../../common/Icon';
import { Indent } from '../../common/Indent';
import { StyledText } from '../../common/StyledText';

interface IProps {
  icon: string;
  title: React.ReactNode;
}

export const FutureBlock: React.FC<IProps> = ({ icon, title }) => {
  const theme = useTheme();
  return (
    <Indent around={1.5} left={0}>
      <Flex align='flex-start' wrap='nowrap'>
        <Indent
          right={1}
          style={{
            marginTop: 5,
          }}>
          <Icon name={icon} width='2.25rem' color={theme.primaryColor} />
        </Indent>
        <StyledText size={1} color='textInverted'>
          {title}
        </StyledText>
      </Flex>
    </Indent>
  );
};
